import { useCallback } from 'react';
import { Field, FieldRenderProps, RenderableProps } from 'react-final-form';
import { ValueBadgeFieldProps, ValueBadgeInputWrapper } from './FormValueBadgeInput';
import { showError } from '../../../design-system';

export const ValueBadgeField = (props: ValueBadgeFieldProps) => {
  const { name, fieldProps, ...rest } = props;

  const renderInput = useCallback<
    NonNullable<RenderableProps<FieldRenderProps<string[]>>['render']>
  >(
    ({ input, meta, helperText }) => {
      const { error, submitError } = meta;
      const isError = showError({ meta });
      return (
        <ValueBadgeInputWrapper
          values={input.value || []}
          onChange={input.onChange}
          helpText={isError ? error || submitError : helperText}
          isError={isError}
          onBlur={input.onBlur}
          {...rest}
        />
      );
    },
    [rest],
  );

  return <Field name={name} render={renderInput} {...fieldProps} />;
};
